import React, { useMemo } from 'react'
import { FaCircle } from "react-icons/fa";
import { Button, Tooltip, message } from "antd";
import { ROLES } from "components/common/Constants";

const PriorityInfo = ({ dispatchButtonConfig, analyzeQuantityConfig }) => {
    const isButtonVisible = dispatchButtonConfig?.visible && typeof dispatchButtonConfig?.onClick === "function";
    const showAnalyzeButton = analyzeQuantityConfig?.role === ROLES.CUTTING || analyzeQuantityConfig?.role === ROLES.ADMIN;
    
    // Calculate total quantity from selected jobcards
    const totalQuantity = useMemo(() => {
        if (!analyzeQuantityConfig?.recordBig || !Array.isArray(analyzeQuantityConfig.recordBig)) {
            return 0;
        }
        return analyzeQuantityConfig.recordBig.reduce((sum, record) => {
            const qty = record?.quantity;
            return sum + (typeof qty === 'number' ? qty : 0);
        }, 0);
    }, [analyzeQuantityConfig?.recordBig]);

    return (
        <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "5px"}}>
            <div class="success-alert">
                <div class="success-content">

                   <div className="success-text">
  <p className="success-title">Production Priority:</p>
  <div className="success-icon">
    <div className="tooltip">
      <FaCircle className="success-icon-inner-one" />
      <span className="tooltiptext">Critical Priority</span>
    </div>
    <div className="tooltip">
      <FaCircle className="success-icon-inner-two" />
      <span className="tooltiptext">High Priority</span>
    </div>
    <div className="tooltip">
      <FaCircle className="success-icon-inner-three" />
      <span className="tooltiptext">Medium Priority</span>
    </div>
    <div className="tooltip">
      <FaCircle className="success-icon-inner-four" />
      <span className="tooltiptext">Low Priority</span>
    </div>
  </div>
</div>
                </div>
            </div>
            <div class="success-alert" style={{ flex: 2, minWidth: "550px" }}>
                <div class="success-content">

                    <div class="success-text" style={{ display: "flex", alignItems: "center", width: "100%", flexWrap: "nowrap", justifyContent: "flex-start", gap: "15px" }}>
                        <div style={{ display: "flex", alignItems: "center", flexWrap: "nowrap", whiteSpace: "nowrap" }}>
                            <p class="success-title" style={{ margin: 0, whiteSpace: "nowrap" }}>Delivery Schedule</p>
                            <div class="success-icon" style={{ display: "flex", alignItems: "center", gap: "4px", flexShrink: 0 }}>
                                <div className="tooltip">
      <FaCircle className="success-icon-inner-five" />
      <span className="tooltiptext">Delivery Overdue</span>
    </div>
    <div className="tooltip">
      <FaCircle className="success-icon-inner-six" />
      <span className="tooltiptext">Today's Delivery</span>
    </div>
                            </div>
                        </div>
                        {showAnalyzeButton && (
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <Tooltip title="Analyze the selected jobcards to view quantity summary">
                                    <Button
                                        type="primary"
                                        size="small"
                                        onClick={() => {
                                            if (!analyzeQuantityConfig?.recordBig || analyzeQuantityConfig.recordBig.length === 0) {
                                                message.warning("Please select at least one jobcard to analyze quantities");
                                                return;
                                            }
                                            analyzeQuantityConfig?.setGenerateShow(true);
                                        }}
                                        style={{
                                            background: "var(--color-primary)",
                                            borderColor: "var(--color-primary)",
                                            color: "var(--light)",
                                            whiteSpace: "nowrap",
                                            fontSize: "13px",
                                            padding: "6px 20px",
                                            height: "32px",
                                            minWidth: "250px",
                                        }}
                                    >
                                        Analyze Quantity <span style={{ marginLeft: "8px", fontWeight: "600" }}>({totalQuantity})</span>
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Reset current selections">
                                    <Button
                                        type="default"
                                        size="small"
                                        onClick={() => {
                                            analyzeQuantityConfig?.setRecordBig([]);
                                            analyzeQuantityConfig?.setSelectedRowKeys([]);
                                        }}
                                        style={{
                                            border: "1px solid var(--color-primary)",
                                            color: "var(--color-primary)",
                                            background: "transparent",
                                            fontSize: "12px",
                                            padding: "4px 8px",
                                            height: "28px"
                                        }}
                                    >
                                        ✕
                                    </Button>
                                </Tooltip>
                            </div>
                        )}
                        {isButtonVisible && (
                            <Button
                                type="primary"
                                onClick={dispatchButtonConfig.onClick}
                                disabled={dispatchButtonConfig.disabled}
                                style={{ whiteSpace: "nowrap", marginLeft: showAnalyzeButton ? "10px" : "70px" }}
                            >
                                Fill Dispatch Details
                            </Button>
                        )}
                    </div>
                      
                </div>
            </div>
        </div>
    )
}

export default PriorityInfo